<template>
  <Cfg>
    <slot>
      <div class="animated fadeIn">
        <Alerts ref="alert"/>
        <Forms ref="frmGroup"
          :title="this.$lang.Area.TitleForm"
          :showHelp="true"
          :showClearButton="true"
          :showSaveButton="true"
          v-on:Clear="onClear"
          v-on:Save="onSave">
          <div class="form-group row">
            <div class="col-md-6">
              <label for="txtAreaName"><small class="text-danger">*</small> {{$lang.Area.LabelName}}:</label>
              <div class="input-group">
                <b-form-input type="text"
                              name="txtAreaName"
                              :placeholder="$lang.Area.PlaceholderEnterName"
                              v-model="form.name.value"
                              :maxlength="form.name.maxlength"
                              :required="form.name.required"
                              :state="form.name.state"></b-form-input>
              </div>
            </div>
            <div class="col-md-6">
              <label for="txtMnemonic"><small class="text-danger">*</small> {{$lang.Area.LabelMnemonic}}:</label>
              <div class="input-group">
                <b-form-input type="text"
                              id="txtMnemonic"
                              name="txtMnemonic"
                              :placeholder="$lang.Area.PlaceholderEnterMnemonic"
                              v-model="form.mnemonic.value"
                              :maxlength="form.mnemonic.maxlength"
                              :required="form.mnemonic.required"
                              :state="form.mnemonic.state"></b-form-input>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-12">
              <label for="txtDescription"> {{$lang.Area.LabelDescription}}:</label>
              <b-form-textarea id="txtDescription"
                          name="txtDescription"
                          v-model.trim="form.description.value"
                          :placeholder="$lang.Area.PlaceholderEnterDescription"
                          :rows="form.description.rows"
                          :maxlength="form.description.maxlength"
                          :noResize="form.description.noResize"></b-form-textarea>
              <small class="small-help"><i class="fa fa-info-circle"></i> <span v-html="FieldSizeTip"></span>.</small>
            </div>
          </div>
        </Forms>

        <Tables ref="tableGrid"
            :columns="[$lang.Area.DataTable.Name,
                       $lang.Area.DataTable.Mnemonic,
                       $lang.Common.DataTable.Status,
                       $lang.Common.DataTable.ActionDate,
                       $lang.Common.DataTable.AccountAction,
                       $lang.Common.DataTable.Actions]"
            :showSearch="true"
            :showPrint="true"
            :showDownload="true"
            :showFullscreen="true"
            v-on:Load="onLoad">
          <tr v-for="obj in this.objList" v-bind:key="obj.id">
            <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.name" classCss="text-left" />
            <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.mnemonic" />
            <TableColumn :IsStatus="true" v-on:Edit="onEdit(obj)" :status="obj.status" />
            <TableColumn :IsDatetime="true" v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.dateUpdate" />
            <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.accountUserNameUpdate" />
            <TableColumn :IsActionsButtons="true" v-on:Change="onChange(obj)" v-on:Delete="onDelete(obj)" :status="obj.status" />
          </tr>
        </Tables>
      </div>
    </slot>
  </Cfg>
</template>

<script>
import Area from './area.js'

export default Area
</script>



// WEBPACK FOOTER //
// src/views/private/configuration/area/area.vue